import { InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { IconCloseCircle } from '../../../assets/icons'
import './index.scss'

export default function BaseInput({ className = '', inputClassName = '', error, success, buttonRight, showClear = false, onClear, ...props }) {
  const shouldShowClear = showClear && !props.disabled && typeof onClear === 'function'

  return (
    <div className={`BaseInput ${error ? 'BaseInput--has-error' : ''} ${success ? 'BaseInput--has-success' : ''} ${className}`.trim()}>
      <div className="BaseInput_wrapper">
        <div className="BaseInput_inputWrapper">
          <input
            className={`BaseInput_input ${error ? 'BaseInput_input--error' : ''} ${success && !error ? 'BaseInput_input--success' : ''} ${shouldShowClear ? 'BaseInput_input--has-clear' : ''} ${inputClassName}`.trim()}
            {...props}
          />
          {shouldShowClear && (
            <button
              type="button"
              className="BaseInput_clearButton"
              aria-label="Xóa nội dung"
              onMouseDown={(event) => event.preventDefault()}
              onClick={onClear}>
              <IconCloseCircle />
            </button>
          )}
        </div>
        {buttonRight && <div className="BaseInput_buttonRight">{buttonRight}</div>}
      </div>
      {error && (
        <span className="BaseInput_error">
          <InfoCircleOutlined style={{ fontSize: '13px', marginRight: '4px' }} />
          {error}
        </span>
      )}
      {!error && success && (
        <span className="BaseInput_success">
          <CheckCircleOutlined style={{ fontSize: '13px', marginRight: '4px' }} />
          {success}
        </span>
      )}
    </div>
  )
}
